import {
  FONT_SIZE_DEFAULT_PX,
  FONT_SIZE_MAX_PX,
  FONT_SIZE_MIN_PX,
  FONT_SIZE_STEP_PX,
} from '@/shared/constants/font-size';
import {
  applyFontSizePx,
  loadFontSizePx,
  saveFontSizePx,
} from '@/shared/utils/font-size';
import { useCallback, useState } from 'react';

export function useFontSize() {
  const [sizePx, setSizePx] = useState(loadFontSizePx);

  const setAndApply = useCallback((next: number) => {
    const applied = applyFontSizePx(next);
    setSizePx(applied);
    saveFontSizePx(applied);
  }, []);

  const decrease = useCallback(() => {
    setAndApply(sizePx - FONT_SIZE_STEP_PX);
  }, [sizePx, setAndApply]);

  const increase = useCallback(() => {
    setAndApply(sizePx + FONT_SIZE_STEP_PX);
  }, [sizePx, setAndApply]);

  const reset = useCallback(() => {
    setAndApply(FONT_SIZE_DEFAULT_PX);
  }, [setAndApply]);

  return {
    sizePx,
    decrease,
    increase,
    reset,
    isDefault: sizePx === FONT_SIZE_DEFAULT_PX,
    canDecrease: sizePx > FONT_SIZE_MIN_PX,
    canIncrease: sizePx < FONT_SIZE_MAX_PX,
  };
}
